import React from 'react';
export function SectionImageDouble() {
  return <section style={{
    background: '#ffffff',
    padding: 0,
    margin: 0
  }} data-id="element-123">
      <img src="https://cdn.shopify.com/s/files/1/1019/9361/1596/files/image_57.png?v=1772971629" alt="Imagen informativa 1" className="w-full block" style={{
      display: 'block',
      margin: 0,
      padding: 0
    }} data-id="element-124" />
      <img src="https://cdn.shopify.com/s/files/1/1019/9361/1596/files/hf_20260302_190651_55bf7ad9-1b99-4b36-bef0-e3b10541bd72.jpg?v=1772971630" alt="Imagen informativa 2" className="w-full block" style={{
      display: 'block',
      margin: 0,
      padding: 0
    }} data-id="element-125" />
    </section>;
}